<div class="loading-overlay">
  <div class="dots">
    <span></span>
  </div>
</div>
